module.exports = __webpack_public_path__ + "img/procu.d247f3be.png";